import React from 'react'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  type ChartData,
  type ChartOptions
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend)

export interface RefundAnalyticsDoughnutProps {
  totalPaid: number
  totalRefunded: number
  refundedColor: string
  remainingColor: string
}

const baseOptions: ChartOptions<'doughnut'> = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '68%',
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        padding: 14,
        font: { size: 11, weight: 'bold' }
      }
    },
    tooltip: {
      callbacks: {
        label: (ctx) => {
          const raw = ctx.raw
          const v = typeof raw === 'number' ? raw : 0
          const label = ctx.label ?? ''
          return `${label}: ${v.toLocaleString()} Rwf`
        }
      }
    }
  }
}

export function RefundAnalyticsDoughnut(props: RefundAnalyticsDoughnutProps): JSX.Element {
  const { totalPaid, totalRefunded, refundedColor, remainingColor } = props
  const remaining = Math.max(0, totalPaid - totalRefunded)
  const refunded = Math.max(0, totalRefunded)

  const data: ChartData<'doughnut'> = {
    labels: ['Refunded', 'Remaining to Refund'],
    datasets: [
      {
        data: [refunded, remaining],
        backgroundColor: [refundedColor, remainingColor],
        borderColor: '#ffffff',
        borderWidth: 2,
        hoverOffset: 6
      }
    ]
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: 300 }}>
      <Doughnut data={data} options={baseOptions} />
      <div
        style={{
          position: 'absolute',
          top: '44%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          pointerEvents: 'none'
        }}
      >
        <div
          style={{
            fontSize: '11px',
            fontWeight: '600',
            color: '#6b7280',
            marginBottom: '4px'
          }}
        >
          Total Paid
        </div>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#667eea',
            lineHeight: '1.2'
          }}
        >
          {(totalPaid / 1000000000).toFixed(2)}B
        </div>
        <div
          style={{
            fontSize: '9px',
            color: '#9ca3af',
            marginTop: '2px'
          }}
        >
          Rwf
        </div>
      </div>
    </div>
  )
}
